import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserFossilFinderGame from 'src/games/FossilFinderGame/Main';

interface FossilFinderGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class FossilFinderGame extends React.Component<FossilFinderGameProps> {
    constructor(props: FossilFinderGameProps) {
        super(props);
        bindAllOfThis(this, FossilFinderGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserFossilFinderGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default FossilFinderGame;



// WEBPACK FOOTER //
// ./src/pages/game/FossilFinderGame.tsx